import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DocLinkType } from 'routes/routes';
import { ResourceList } from './ResourceList';
import { fetchDocument, resetDocument } from './documentsLink';

const LinkDocumentResource = () => {
  const dispatch = useDispatch();
  const { documentId, linkType } = useParams<{ documentId: string; linkType: string }>();

  useEffect(() => {
    dispatch(fetchDocument(documentId));
    return () => {
      dispatch(resetDocument());
    };
  }, []);

  return (
    <>
      {linkType === DocLinkType.PRODUCT && <ResourceList documentId={documentId} linkType={DocLinkType.PRODUCT} />}
      {linkType === DocLinkType.SERIAL_NUMBER && (
        <ResourceList
          documentId={documentId}
          linkType={DocLinkType.SERIAL_NUMBER}
          searchLabelKey={`${DocLinkType.SERIAL_NUMBER} or ${DocLinkType.PRODUCT}`}
        />
      )}
      {linkType === DocLinkType.ORDER_LIST && (
        <ResourceList documentId={documentId} linkType={DocLinkType.ORDER_LIST} />
      )}
    </>
  );
};

export { LinkDocumentResource };
